// Copyright (c) Bentley Systems
import { KeyValue } from "./key-value";

export class MatchCodeItem {
  public enumMatchCodeItemId: number | undefined;
  public matchCodeId: number | undefined;
  public text: string | undefined;
  public value: string | undefined;
  public filterKeyValues: KeyValue[] = [];
  constructor(initializer?: any) {
    if (initializer.enumMatchCodeItemId)
      {this.enumMatchCodeItemId = initializer.enumMatchCodeItemId;}
    if (initializer.matchCodeId) {this.matchCodeId = initializer.matchCodeId;}
    if (initializer.text) {this.text = initializer.text;}
    if (initializer.value) {this.value = initializer.value;}
    if (initializer.filterKeyValues)
      {this.filterKeyValues = initializer.filterKeyValues;}
  }
}
